<template>
  <div class="col-12 col-md-12 col-lg-8">
    <div class="tit text-center">
      <p>Qual é o saldo das dívidas bancárias?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">    
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="valor-divida-bancaria" class="float-left">Valor da Dívida</label>
            <input type="text" class="form-control form-control-lg" v-model="valorDividaBancaria" v-mask="'money'" placeholder="R$" required>
          </div>
          <div class="text-center fixedOptions">
            <button :disabled="dividaValida" class="btn btn-lg btn-primary float-right">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Masker from '@/utils/masker'

export default {
  data() {
    const valorDividaBancaria = this.solicitacao.Empresa.ValorDividaBancaria
    return {
      valorDividaBancaria: valorDividaBancaria ? valorDividaBancaria.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) : null
    }
  },
  computed: {
    dividaValida: function() { return parseFloat(this.valorDividaBancaria) <= 0 }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {
        Empresa: {
          ValorDividaBancaria: Masker.formatReal(this.valorDividaBancaria)
        }
      }
      this.$emit('on-submit', newData)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/BankDebtValueStep.vue